
export const REMOVE_ACTIVE_LAYERS = 'REMOVE_ACTIVE_LAYERS';
export const REMOVE_ACTIVE_LAYER = 'REMOVE_ACTIVE_LAYER';
export const REMOVE_ALL_LAYERS = 'REMOVE_ALL_LAYERS'
export const SET_ACTIVE_LAYER_VISIBLE = 'SET_ACTIVE_LAYER_VISIBLE';
export const HIDE_ACTIVE_LAYERS = 'HIDE_ACTIVE_LAYERS'
export const REORDER_ACTIVE_LAYERS = 'REORDER_ACTIVE_LAYERS';
export const SET_OR_CREATE_NEW_ACTIVE_LAYER = 'SET_OR_CREATE_NEW_ACTIVE_LAYER';
export const SET_OR_CREATE_NEW_ACTIVE_LAYERS = 'SET_OR_CREATE_NEW_ACTIVE_LAYERS';
export const SET_ACTIVE_LAYER_STYLING = 'SET_ACTIVE_LAYER_STYLING';
export const SET_ACTIVE_LAYER_PRINTABLE = 'SET_ACTIVE_LAYER_PRINTABLE';
export const SET_ALL_ACTIVE_LAYERS_PRINTABLE = 'SET_ALL_ACTIVE_LAYERS_PRINTABLE';